/* eslint-disable import/extensions */
import React from 'react';
import { Fade } from 'react-awesome-reveal';
import heroImage from 'assets/images/hero/companies.png';

export default function CharterHero() {
  return (
    <section className="relative w-full overflow-hidden">

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto flex flex-col sm:flex-row sm:items-center lg:items-start py-20 px-5 sm:px-12">
        
        {/* Left Column */}
        <div className="w-full sm:w-1/2 flex flex-col">
          <Fade direction="up" triggerOnce>
            <h1 className="text-5xl sm:text-6xl text-theme-purple font-bold pt-24 leading-tight mb-5">
              For Companies <br />
            </h1>
          </Fade>
          
        </div>

        {/* Right Column - Image */}
        <div className="w-full sm:w-3/4 mt-10 sm:mt-0">
          <Fade direction="up" triggerOnce>
            <img src={heroImage} alt="Charter Hero" className="w-full" />
          </Fade>
        </div>

      </div>
    </section>
  );
}
